import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getAuthCheck } from '@lingoda/auth';
import { config, getApolloDevToolsEnabled } from '@lingoda/config';
import { MonitorLink } from '@lingoda/monitor';
import { goTo, logoutPath } from '@lingoda/router';
import { createQuizCache } from './createQuizCache';

const QUIZ_API_URL = `${config.quizEngineEndpoint}/graphql`;

const handleAuthFailure = () => {
    console.error('Quiz auth failed');
    // While Quiz reuses the same Bearer token as the main backend, it's safe to logout here
    goTo(logoutPath());
};

// Make sure the shared `BEARER` cookie is fresh before each request so Quiz receives a valid token.
const authLink = setContext(async () => {
    await getAuthCheck(QUIZ_API_URL, handleAuthFailure);

    return {};
});

export const createQuizClient = () => {
    return new ApolloClient({
        cache: createQuizCache(),
        link: ApolloLink.from([
            new MonitorLink({
                uri: QUIZ_API_URL,
                setFingerprint: false,
                setTransaction: false,
                attachBreadcrumbs: {
                    includeVariables: true,
                    includeError: true,
                },
            }),
            authLink,
            new HttpLink({
                uri: QUIZ_API_URL,
                credentials: 'include',
            }),
        ]),
        devtools: {
            enabled: getApolloDevToolsEnabled(),
            name: 'Quiz',
        },
    });
};
